<section class="container">
  <div class="row">
    <div class="feedback-heading">Feedback</div>
    <div class="feedback-description">
      We would love to get your feedback for the {{this.uiForType}} that was addressed recently.
      <div class="row row-cols-6">
        <div class="col-md-6 col-12">
          <div class="row p-2">
            <div class="col-4">Query ID</div>
            <div class="col">{{ this.forDisplayId }}</div>
          </div>
          <div class="row p-2">
            <div class="col-4">Query Name</div>
            <div class="col">{{ this.forName }}</div>
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let feedbackQuestion of questions; let i = index"
         class="question-container">
      <span>
        <label>{{ feedbackQuestion.question }}</label>
      </span>
      <div class="rating-panel">
        <ng-container *ngFor="let j of [1, 2, 3, 4, 5]">
          <i
            [class]="selectedRating[i+1] >= j ? 'fa fa-star star-icon rating' : 'fa fa-star star-icon'"
            aria-hidden="true"
            (click)="setRating(i+1, j)"></i>

        </ng-container>
      </div>
    </div>
    <form [formGroup]="feedbackForm">
      <div class="col-8">
        <div class="mb-3">
          <label for="exampleFormControlTextarea1"
                 class="form-label">Explain more about your experience here</label>
          <textarea class="form-control" id="exampleFormControlTextarea1" rows="4"
                    formControlName="description"></textarea>
        </div>
      </div>
    </form>
  </div>
  <div class="col-12 d-flex justify-content-end z-index">
    <a>
      <button type="button" class="btn-discard" (click)="remindMeLater()">REMIND ME LATER</button>
    </a>
    <a>
      <button type="button" class="btn-actvtytp" (click)="submitFeedbackResponse()">
        SAVE & EXIT
      </button>
    </a>

    <a>
      <button type="button" class="btn-discard" (click)="dismissFeedbackResponse()">DISMISS</button>
    </a>
  </div>
</section>
